var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { action, observable, makeObservable, runInAction } from 'mobx';
import { getAxios } from '../../backend';
import { API_PATH, SESSION_STORAGE_KEYS } from '../../constants';
import { Scenarios, EventName, } from '@whatsper/texterchat-common';
class ScenariosStore {
    constructor(rootStore) {
        Object.defineProperty(this, "rootStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "scenarios", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: observable([])
        });
        Object.defineProperty(this, "runs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: observable([])
        });
        Object.defineProperty(this, "totalRuns", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "runsPage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 1
        });
        Object.defineProperty(this, "runsPageSize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 10
        });
        Object.defineProperty(this, "runsFilters", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "loading", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "includeSystemScenarios", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "events", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: observable({})
        });
        Object.defineProperty(this, "conditions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: observable({})
        });
        Object.defineProperty(this, "loaders", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: observable({})
        });
        Object.defineProperty(this, "actions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: observable({})
        });
        Object.defineProperty(this, "clearRuns", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.runs.clear();
                this.totalRuns = 0;
                this.runsPage = 1;
                this.runsFilters = {
                    sortStarted: 'desc',
                };
                this.saveRunsFiltersToStorage();
            }
        });
        Object.defineProperty(this, "saveRunsFiltersToStorage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                try {
                    const _a = this.runsFilters, { scenarioId } = _a, filtersToSave = __rest(_a, ["scenarioId"]);
                    sessionStorage.setItem(SESSION_STORAGE_KEYS.SCENARIO_RUNS_FILTERS, JSON.stringify(filtersToSave));
                }
                catch (error) {
                    console.error('Failed to save scenario runs filters to session storage:', error);
                }
            }
        });
        Object.defineProperty(this, "restoreRunsFiltersFromStorage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                try {
                    const stored = sessionStorage.getItem(SESSION_STORAGE_KEYS.SCENARIO_RUNS_FILTERS);
                    if (stored) {
                        const filters = JSON.parse(stored);
                        if (!filters.sortStarted && !filters.sortExecutionTime) {
                            filters.sortStarted = 'desc';
                        }
                        return filters;
                    }
                }
                catch (error) {
                    console.error('Failed to restore scenario runs filters from session storage:', error);
                }
                return { sortStarted: 'desc' };
            }
        });
        // Components definitions
        Object.defineProperty(this, "fetchEvents", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => __awaiter(this, void 0, void 0, function* () {
                try {
                    const { data } = yield getAxios().then((axios) => axios.get(`${API_PATH.SCENARIOS}/components/events`));
                    runInAction(() => (this.events = data));
                }
                catch (error) {
                    console.error('Failed to fetch scenario events', error);
                    throw error;
                }
            })
        });
        Object.defineProperty(this, "fetchConditions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => __awaiter(this, void 0, void 0, function* () {
                try {
                    const { data } = yield getAxios().then((axios) => axios.get(`${API_PATH.SCENARIOS}/components/conditions`));
                    runInAction(() => (this.conditions = data));
                }
                catch (error) {
                    console.error('Failed to fetch scenario conditions', error);
                    throw error;
                }
            })
        });
        Object.defineProperty(this, "fetchLoaders", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => __awaiter(this, void 0, void 0, function* () {
                try {
                    const { data } = yield getAxios().then((axios) => axios.get(`${API_PATH.SCENARIOS}/components/loaders`));
                    runInAction(() => (this.loaders = data));
                }
                catch (error) {
                    console.error('Failed to fetch scenario loaders', error);
                    throw error;
                }
            })
        });
        Object.defineProperty(this, "fetchActions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => __awaiter(this, void 0, void 0, function* () {
                try {
                    const { data } = yield getAxios().then((axios) => axios.get(`${API_PATH.SCENARIOS}/components/actions`));
                    runInAction(() => (this.actions = data));
                }
                catch (error) {
                    console.error('Failed to fetch scenario actions', error);
                    throw error;
                }
            })
        });
        // Scenarios performed runs
        Object.defineProperty(this, "fetchRuns", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => __awaiter(this, void 0, void 0, function* () {
                const query = Object.assign(Object.assign({}, this.runsFilters), { skip: (this.runsPage - 1) * this.runsPageSize, limit: this.runsPageSize, includeSystem: this.includeSystemScenarios });
                this.loading = true;
                try {
                    const { data } = yield getAxios().then((axios) => axios.get(`${API_PATH.SCENARIOS}/runs`, { params: query }));
                    runInAction(() => {
                        this.runs.replace(data.runs);
                        this.totalRuns = data.total;
                        this.loading = false;
                    });
                }
                catch (error) {
                    console.error('Failed to fetch scenario runs', error);
                    runInAction(() => {
                        this.loading = false;
                    });
                    throw error;
                }
            })
        });
        Object.defineProperty(this, "setRunsPage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (page) => {
                this.runsPage = page;
                this.fetchRuns();
            }
        });
        Object.defineProperty(this, "setRunsPageSize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (pageSize) => {
                this.runsPageSize = pageSize;
                this.runsPage = 1; // Reset to first page
                this.fetchRuns();
            }
        });
        Object.defineProperty(this, "setRunsFilters", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (filters) => {
                this.runsFilters = filters;
                this.runsPage = 1; // Reset to first page
                this.saveRunsFiltersToStorage();
                this.fetchRuns();
            }
        });
        Object.defineProperty(this, "setRunsFiltersForScenario", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (scenarioId) => {
                const storedFilters = this.restoreRunsFiltersFromStorage();
                this.runsFilters = Object.assign(Object.assign({}, storedFilters), { scenarioId });
                this.runsPage = 1;
                this.fetchRuns();
            }
        });
        Object.defineProperty(this, "setRunsConfig", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (page, pageSize, filters) => {
                this.runsPage = page;
                this.runsPageSize = pageSize;
                this.runsFilters = filters;
                this.saveRunsFiltersToStorage();
                this.fetchRuns();
            }
        });
        // Scenarios management
        Object.defineProperty(this, "setIncludeSystemScenarios", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (include) => {
                this.includeSystemScenarios = include;
            }
        });
        Object.defineProperty(this, "fetchScenarios", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (query) => __awaiter(this, void 0, void 0, function* () {
                try {
                    const finalQuery = Object.assign(Object.assign({}, query), { includeSystem: this.includeSystemScenarios });
                    const { data } = yield getAxios().then((axios) => axios.get(`${API_PATH.SCENARIOS}/manage`, { params: finalQuery }));
                    runInAction(() => this.scenarios.replace(data.scenarios));
                }
                catch (error) {
                    console.error('Failed to fetch scenarios:', error);
                    throw error;
                }
            })
        });
        Object.defineProperty(this, "createScenario", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (scenarioData) => __awaiter(this, void 0, void 0, function* () {
                try {
                    const { data } = yield getAxios().then((axios) => axios.post(`${API_PATH.SCENARIOS}/manage`, scenarioData));
                    runInAction(() => this.upsertScenario(data));
                    return data;
                }
                catch (error) {
                    console.error('Failed to create scenario', error);
                    throw error;
                }
            })
        });
        Object.defineProperty(this, "deleteScenario", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (id) => __awaiter(this, void 0, void 0, function* () {
                try {
                    yield getAxios().then((axios) => axios.delete(`${API_PATH.SCENARIOS}/manage/${id}`));
                    runInAction(() => {
                        const updatedScenarios = this.scenarios.filter((s) => s._id !== id);
                        this.scenarios.replace(updatedScenarios);
                    });
                }
                catch (error) {
                    console.error(`Failed to delete scenario ${id}`, error);
                    throw error;
                }
            })
        });
        Object.defineProperty(this, "copyScenario", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (id) => __awaiter(this, void 0, void 0, function* () {
                try {
                    const { data } = yield getAxios().then((axios) => axios.post(`${API_PATH.SCENARIOS}/manage/${id}/copy`));
                    runInAction(() => this.upsertScenario(data));
                    return data;
                }
                catch (error) {
                    console.error(`Failed to copy scenario ${id}`, error);
                    throw error;
                }
            })
        });
        Object.defineProperty(this, "createDraft", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (id, body) => __awaiter(this, void 0, void 0, function* () {
                try {
                    const { data } = yield getAxios().then((axios) => axios.post(`${API_PATH.SCENARIOS}/manage/${id}/draft`, body));
                    runInAction(() => this.upsertScenario(data));
                    return data;
                }
                catch (error) {
                    console.error(`Failed to create draft for scenario ${id}`, error);
                    throw error;
                }
            })
        });
        Object.defineProperty(this, "discardDraft", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (id) => __awaiter(this, void 0, void 0, function* () {
                try {
                    const { data } = yield getAxios().then((axios) => axios.delete(`${API_PATH.SCENARIOS}/manage/${id}/draft`));
                    runInAction(() => this.upsertScenario(data));
                }
                catch (error) {
                    console.error(`Failed to discard draft for scenario ${id}`, error);
                    throw error;
                }
            })
        });
        Object.defineProperty(this, "editDraft", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (id, draftData) => __awaiter(this, void 0, void 0, function* () {
                try {
                    const { data } = yield getAxios().then((axios) => axios.patch(`${API_PATH.SCENARIOS}/manage/${id}/draft`, draftData));
                    runInAction(() => this.upsertScenario(data));
                    return data;
                }
                catch (error) {
                    console.error(`Failed to edit draft for scenario ${id}`, error);
                    throw error;
                }
            })
        });
        Object.defineProperty(this, "promoteToRevision", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (id, comment) => __awaiter(this, void 0, void 0, function* () {
                const params = {
                    comment,
                };
                try {
                    const { data } = yield getAxios().then((axios) => axios.post(`${API_PATH.SCENARIOS}/manage/${id}/revisions`, params));
                    runInAction(() => this.upsertScenario(data));
                    return data;
                }
                catch (error) {
                    console.error(`Failed to promote draft to revision for scenario ${id}`, error);
                    throw error;
                }
            })
        });
        Object.defineProperty(this, "inactivateRevision", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (id) => __awaiter(this, void 0, void 0, function* () {
                try {
                    const { data } = yield getAxios().then((axios) => axios.post(`${API_PATH.SCENARIOS}/manage/${id}/revisions/inactivate`));
                    runInAction(() => this.upsertScenario(data));
                    return data;
                }
                catch (error) {
                    console.error(`Failed to inactivate revision for scenario ${id}`, error);
                    throw error;
                }
            })
        });
        Object.defineProperty(this, "activateRevision", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (id, version) => __awaiter(this, void 0, void 0, function* () {
                try {
                    const { data } = yield getAxios().then((axios) => axios.post(`${API_PATH.SCENARIOS}/manage/${id}/revisions/${version}/activate`));
                    runInAction(() => this.upsertScenario(data));
                    return data;
                }
                catch (error) {
                    console.error(`Failed to activate revision ${version} for scenario ${id}`, error);
                    throw error;
                }
            })
        });
        Object.defineProperty(this, "deleteRevision", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (id, version) => __awaiter(this, void 0, void 0, function* () {
                try {
                    const { data } = yield getAxios().then((axios) => axios.delete(`${API_PATH.SCENARIOS}/manage/${id}/revisions/${version}`));
                    this.upsertScenario(data);
                }
                catch (error) {
                    console.error(`Failed to delete revision ${version} for scenario ${id}`, error);
                    throw error;
                }
            })
        });
        Object.defineProperty(this, "importScenario", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (request) => __awaiter(this, void 0, void 0, function* () {
                try {
                    const { data } = yield getAxios().then((axios) => axios.post(`${API_PATH.SCENARIOS}/manage/import`, request));
                    runInAction(() => this.upsertScenario(data));
                    return data;
                }
                catch (error) {
                    console.error('Failed to import scenario', error);
                    throw error;
                }
            })
        });
        makeObservable(this);
        this.rootStore = rootStore;
        this.rootStore.events
            .addListener(EventName.scenario_created, (data) => this.onScenarioCreatedEvent(data))
            .addListener(EventName.scenario_deleted, (data) => this.onScenarioDeletedEvent(data))
            .addListener(EventName.scenario_draft_started, (data) => this.onScenarioDraftStartedEvent(data))
            .addListener(EventName.scenario_draft_discarded, (data) => this.onScenarioDraftDiscardedEvent(data))
            .addListener(EventName.scenario_revision_created, (data) => this.onScenarioRevisionCreatedEvent(data))
            .addListener(EventName.scenario_revision_activated, (data) => this.onScenarioRevisionActivatedEvent(data))
            .addListener(EventName.scenario_revision_inactivated, (data) => this.onScenarioRevisionInactivatedEvent(data))
            .addListener(EventName.scenario_revision_deleted, (data) => this.onScenarioRevisionDeletedEvent(data))
            .addListener(EventName.scenario_event_added, (data) => this.onScenarioEventAddedEvent(data))
            .addListener(EventName.scenario_event_removed, (data) => this.onScenarioEventRemovedEvent(data))
            .addListener(EventName.scenario_loader_added, (data) => this.onScenarioLoaderAddedEvent(data))
            .addListener(EventName.scenario_loader_removed, (data) => this.onScenarioLoaderRemovedEvent(data))
            .addListener(EventName.scenario_condition_added, (data) => this.onScenarioConditionAddedEvent(data))
            .addListener(EventName.scenario_condition_removed, (data) => this.onScenarioConditionRemovedEvent(data))
            .addListener(EventName.scenario_action_added, (data) => this.onScenarioActionAddedEvent(data))
            .addListener(EventName.scenario_action_removed, (data) => this.onScenarioActionRemovedEvent(data))
            .addListener(EventName.scenario_options_updated, (data) => this.onScenarioOptionsUpdatedEvent(data))
            .addListener(EventName.scenario_name_updated, (data) => this.onScenarioNameUpdatedEvent(data))
            .addListener(EventName.scenario_description_updated, (data) => this.onScenarioDescriptionUpdatedEvent(data))
            .addListener(EventName.scenario_loop_added, (data) => this.onScenarioLoopAddedEvent(data))
            .addListener(EventName.scenario_loop_removed, (data) => this.onScenarioLoopRemovedEvent(data));
    }
    upsertScenario(scenario) {
        const index = this.scenarios.findIndex((s) => s._id === scenario._id);
        if (index > -1) {
            this.scenarios[index] = scenario;
        }
        else {
            this.scenarios.push(scenario);
        }
    }
    onScenarioCreatedEvent(eventData) {
        this.upsertScenario(eventData.scenario);
    }
    onScenarioDeletedEvent(eventData) {
        const id = eventData.scenario._id;
        const updated = this.scenarios.filter((s) => s._id !== id);
        this.scenarios.replace(updated);
    }
    onScenarioDraftStartedEvent(eventData) {
        this.upsertScenario(eventData.scenario);
    }
    onScenarioDraftDiscardedEvent(eventData) {
        this.upsertScenario(eventData.scenario);
    }
    onScenarioRevisionCreatedEvent(eventData) {
        this.upsertScenario(eventData.scenario);
    }
    onScenarioRevisionActivatedEvent(eventData) {
        this.upsertScenario(eventData.scenario);
    }
    onScenarioRevisionInactivatedEvent(eventData) {
        this.upsertScenario(eventData.scenario);
    }
    onScenarioRevisionDeletedEvent(eventData) {
        this.upsertScenario(eventData.scenario);
    }
    onScenarioEventAddedEvent(eventData) {
        this.upsertScenario(eventData.scenario);
    }
    onScenarioEventRemovedEvent(eventData) {
        this.upsertScenario(eventData.scenario);
    }
    onScenarioLoaderAddedEvent(eventData) {
        this.upsertScenario(eventData.scenario);
    }
    onScenarioLoaderRemovedEvent(eventData) {
        this.upsertScenario(eventData.scenario);
    }
    onScenarioConditionAddedEvent(eventData) {
        this.upsertScenario(eventData.scenario);
    }
    onScenarioConditionRemovedEvent(eventData) {
        this.upsertScenario(eventData.scenario);
    }
    onScenarioActionAddedEvent(eventData) {
        this.upsertScenario(eventData.scenario);
    }
    onScenarioActionRemovedEvent(eventData) {
        this.upsertScenario(eventData.scenario);
    }
    onScenarioOptionsUpdatedEvent(eventData) {
        this.upsertScenario(eventData.scenario);
    }
    onScenarioNameUpdatedEvent(eventData) {
        this.upsertScenario(eventData.scenario);
    }
    onScenarioDescriptionUpdatedEvent(eventData) {
        this.upsertScenario(eventData.scenario);
    }
    onScenarioLoopAddedEvent(eventData) {
        this.upsertScenario(eventData.scenario);
    }
    onScenarioLoopRemovedEvent(eventData) {
        this.upsertScenario(eventData.scenario);
    }
}
__decorate([
    observable
], ScenariosStore.prototype, "scenarios", void 0);
__decorate([
    observable
], ScenariosStore.prototype, "runs", void 0);
__decorate([
    observable
], ScenariosStore.prototype, "totalRuns", void 0);
__decorate([
    observable
], ScenariosStore.prototype, "runsPage", void 0);
__decorate([
    observable
], ScenariosStore.prototype, "runsPageSize", void 0);
__decorate([
    observable
], ScenariosStore.prototype, "runsFilters", void 0);
__decorate([
    observable
], ScenariosStore.prototype, "loading", void 0);
__decorate([
    observable
], ScenariosStore.prototype, "includeSystemScenarios", void 0);
__decorate([
    observable
], ScenariosStore.prototype, "events", void 0);
__decorate([
    observable
], ScenariosStore.prototype, "conditions", void 0);
__decorate([
    observable
], ScenariosStore.prototype, "loaders", void 0);
__decorate([
    observable
], ScenariosStore.prototype, "actions", void 0);
__decorate([
    action
], ScenariosStore.prototype, "upsertScenario", null);
__decorate([
    action
], ScenariosStore.prototype, "clearRuns", void 0);
__decorate([
    action
], ScenariosStore.prototype, "fetchEvents", void 0);
__decorate([
    action
], ScenariosStore.prototype, "fetchConditions", void 0);
__decorate([
    action
], ScenariosStore.prototype, "fetchLoaders", void 0);
__decorate([
    action
], ScenariosStore.prototype, "fetchActions", void 0);
__decorate([
    action
], ScenariosStore.prototype, "fetchRuns", void 0);
__decorate([
    action
], ScenariosStore.prototype, "setIncludeSystemScenarios", void 0);
__decorate([
    action
], ScenariosStore.prototype, "onScenarioCreatedEvent", null);
__decorate([
    action
], ScenariosStore.prototype, "onScenarioDeletedEvent", null);
__decorate([
    action
], ScenariosStore.prototype, "onScenarioDraftStartedEvent", null);
__decorate([
    action
], ScenariosStore.prototype, "onScenarioDraftDiscardedEvent", null);
__decorate([
    action
], ScenariosStore.prototype, "onScenarioRevisionCreatedEvent", null);
__decorate([
    action
], ScenariosStore.prototype, "onScenarioRevisionActivatedEvent", null);
__decorate([
    action
], ScenariosStore.prototype, "onScenarioRevisionInactivatedEvent", null);
__decorate([
    action
], ScenariosStore.prototype, "onScenarioRevisionDeletedEvent", null);
__decorate([
    action
], ScenariosStore.prototype, "onScenarioEventAddedEvent", null);
__decorate([
    action
], ScenariosStore.prototype, "onScenarioEventRemovedEvent", null);
__decorate([
    action
], ScenariosStore.prototype, "onScenarioLoaderAddedEvent", null);
__decorate([
    action
], ScenariosStore.prototype, "onScenarioLoaderRemovedEvent", null);
__decorate([
    action
], ScenariosStore.prototype, "onScenarioConditionAddedEvent", null);
__decorate([
    action
], ScenariosStore.prototype, "onScenarioConditionRemovedEvent", null);
__decorate([
    action
], ScenariosStore.prototype, "onScenarioActionAddedEvent", null);
__decorate([
    action
], ScenariosStore.prototype, "onScenarioActionRemovedEvent", null);
__decorate([
    action
], ScenariosStore.prototype, "onScenarioOptionsUpdatedEvent", null);
__decorate([
    action
], ScenariosStore.prototype, "onScenarioNameUpdatedEvent", null);
__decorate([
    action
], ScenariosStore.prototype, "onScenarioDescriptionUpdatedEvent", null);
__decorate([
    action
], ScenariosStore.prototype, "onScenarioLoopAddedEvent", null);
__decorate([
    action
], ScenariosStore.prototype, "onScenarioLoopRemovedEvent", null);
export const buildScenarioExport = (source) => {
    var _a, _b;
    const hasLoops = ((_b = (_a = source.loops) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0;
    if (hasLoops) {
        const exportable = {
            version: Scenarios.Import.ExportImportVersion.v1_1,
            name: source.name,
            description: source.description,
            triggerEvents: source.triggerEvents,
            loaders: source.loaders,
            conditions: source.conditions,
            actions: source.actions,
            loops: source.loops,
            tags: source.tags,
            options: source.options,
        };
        return exportable;
    }
    const exportable = {
        version: Scenarios.Import.ExportImportVersion.v1,
        name: source.name,
        description: source.description,
        triggerEvents: source.triggerEvents,
        loaders: source.loaders,
        conditions: source.conditions,
        actions: source.actions,
        tags: source.tags,
        options: source.options,
    };
    return exportable;
};
export default ScenariosStore;
